export const CLASS_NAMES = {
  label: 'text-purple-500 text-style-f font-semibold',
  button: 'mt-2 text-neutral-900 flex items-center',
  price: 'ml-2 mr-2 text-light font-medium',
};
